import axios from '@axios'

const route = 'stock/purchase_order'

export default {
  namespaced: true,
  state: {
    order: {},
    orders: [],
    products: [],
    supplier: {},
    deliveryDate: '',
    addressee: {},
    taxes: [],
    observations: '',
    conclusion: {},
    status: '',
    step: 'select_supplier', // select_supplier ; order_details ; conclusion
    step_number: 1,
  },
  getters: {
    getStauts(state) {
      return state.status
    },

    /**
     *retona o pedido de compra para editar
     */
    getOrder(state) {
      return state.order
    },

    /**
     * retorna os pedidos de compra da tabela principal
     */
    getOrders(state) {
      return state.orders
    },

    /**
     *  retorna as observações do pedido de compra
     */
    getObservations(state) {
      return state.observations
    },

    /**
     *retorna ao endereco do destinatario
     */
    getAddressee(state) {
      return state.addressee
    },

    /**
     * retorna os dados de conclusão do pedido de compra
     */
    getConclusion(state) {
      return state.conclusion
    },

    /**
     * retone as taxas do pedido de compra
     */
    getTaxes(state) {
      return state.taxes
    },

    /**
     * retorna a data de entrega do pedido de compra
    */
    getDeliveryDate(state) {
      return state.deliveryDate
    },

    /**
     * retorna o numero do passo atual do pedido de compra
    */
    getStepNumber(state) {
      return state.step_number
    },

    /**
     * retorna os produtos do pedido de compra
    */
    getProducts(state) {
      state.products.forEach(element => {
        element.total_cost = element.quantity * parseFloat(element.unit_cost || 0)
        if (element.quantity_received) {
          element.total_cost_received = parseFloat(element.quantity_received) * parseFloat(element.unit_cost)
        }
      })

      return state.products
    },

    /**
     *  retorna o fornecedor do pedido de compra
    */
    getSupplier(state) {
      return state.supplier
    },

    /**
     * retorna o passo atual do pedido de compra
    */
    getStep(state) {
      return state.step
    },

    /**
     * retorna o sub total
     */
    getSubtotal(state) {
      return state.products.reduce((sum, item) => sum + (parseFloat(item.quantity || 0) * parseFloat(item.unit_cost || 0)), 0)
    },

    /**
     * retorna a soma das taxas
     */
    getSumTaxes(state) {
      return state.taxes.reduce((sum, tax) => sum + parseFloat(tax.value || 0), 0)
    },

    getTotal(context, getters) {
      return getters.getSubtotal + getters.getSumTaxes
    },

  },
  mutations: {

    /**
     * define o status do pedido de compra
     */

    setStatus(state, status) {
      state.status = status
    },

    /**
     * define o pedido de compra para editar
     */
    setOrder(state, order) {
      state.order = order

      // state.step = 'order_details'
      // state.step_number = 2
      // state.supplier = JSON.parse(order.supplier_obj)
      // state.deliveryDate = order.delivery_date
      // state.taxes = order.purchase_order_taxes
      // state.products = order.purchase_order_items
      // state.addressee = JSON.parse(order.addressee_obj)
      // state.observations = order.obs
    },

    /**
     * define os pedidos de compra da tabela principal
     */
    setOrders(state, orders) {
      state.orders = orders
    },

    /**
     * define as observações do pedido de compra
     */
    setObservations(state, observations) {
      state.observations = observations
    },

    /**
     * define o endereco do destinatario
     */
    setAddressee(state, addresse) {
      state.addressee = addresse
    },

    /**
    * define os dados de conclusão do pedido de compra
    */
    setConclusion(state, conclusion) {
      state.conclusion = conclusion
    },

    /*
    * define as taxas do pedido de compra
    */
    setTaxes(state, taxes) {
      state.taxes = taxes
    },

    /**
    * define a data de entrega do pedido de compra
    */
    setDeliveryDate(state, deliveryDate) {
      state.deliveryDate = deliveryDate
    },

    /**
     * define o numero do passo atual do pedido de compra
    */
    setStepNumber(state, step_number) {
      state.step_number = step_number
    },

    /**
     * define os produtos do pedido de compra
    */
    setProducts(state, products) {
      state.products = products
    },

    /**
     * define o fornecedor do pedido de compra
    */
    setSupplier(state, supplier) {
      state.supplier = supplier
    },

    /**
     * define o passo atual do pedido de compra
    */
    setStep(state, step) {
      state.step = step
    },

    /*
    * limpa os dados do pedido de compra
    */
    setClear(state) {
      state.order = {}
      state.supplier = {}
      state.products = []
      state.taxes = []
      state.observations = ''
      state.addressee = {}
      state.deliveryDate = ''
      state.conclusion = {}
      state.step = 'select_supplier'
      state.step_number = 1
    },
  },
  actions: {
    loadPurchaseOrder(context, {
      itemsPerPage, page, search, filter,
    }) {
      return axios.post(`${route}/list?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filter)
    },

    /**
     *  cria um novo pedido de compra
     */
    createPurchaseOrder(context) {
      const purchaseOrder = {
        status: context.state.status,
        supplier: context.state.supplier,
        products: context.state.products,
        addressee: context.state.addressee,
        taxes: context.state.taxes,
        observations: context.state.observations,
        delivery_date: context.state.deliveryDate,
        subtotal: context.getters.getSubtotal,
        sum_taxes: context.getters.getSumTaxes,
        total: context.getters.getTotal,
      }
      if (context.state.order.id) {
        // atualiza o pedido de compra
        return axios.put(`${route}/${context.state.order.id}`, purchaseOrder)
      }

      // cria o pedido de compra
      return axios.post(route, purchaseOrder)
    },

    /**
     *  exportar pdf de recebimento de estoque
     */
    exportPdfReceived(context, purchaseOrderId) {
      return axios.get(`${'stock/purchase_entry' + '/export_pdf_receive/'}${purchaseOrderId}`, {
        responseType: 'blob',
      }).catch(() => {

      }).finally(() => {

      })
    },

    /**
     * recebe o pedido de compra
     */
    receiveStock(context) {
      const receiveData = {
        purchase_order_id: context.state.order.id,
        products: context.state.products,
        taxes: context.state.taxes,
        observations: context.state.observations,
        subtotal: context.getters.getSubtotal,
        sum_taxes: context.getters.getSumTaxes,
        total: context.getters.getTotal,
      }

      return axios.post('stock/purchase_entry', receiveData)
    },

    /**
     * carrega os fornecedores cadastrado no sistema
    */
    getSuppliers(context) {
      return axios.get('helper/get_suppliers')
    },
    cancelPuchaseOrder(context, purchaseOrderId) {
      return axios.delete(`${route}/${purchaseOrderId}`)
    },

    /**
     * pega o dados completo do fornecedor
    */
    getDataSupplier(context, supplierId) {
      return axios.get(`helper/get_supplier/${supplierId}`)
    },

    /**
     * retorna os endereços da empresa
    */
    getCompanyAddresses(context) {
      return axios.get('helper/get_company_addresses')
    },

    /**
     *carrega os produtos cadastrados no sistema
     */
    loadProducts(context, {
      itemsPerPage, page, search, category, with_stock,
    }) {
      return axios.get(`helper/get_products/table?page=${
        page
      }&items_per_page=${itemsPerPage
      }&search=${search
      }&category=${category
      }&with_stock=${with_stock}`)
    },

    /**
     * baixar o pedido de compra em PDF
     */
    exportPdf(context, purchaseOrderId) {
      return axios.get(`${route}/export_pdf/${purchaseOrderId}`, {
        responseType: 'blob',
      })
    },

    /**
     * histórico de atividades do pedido de compra
     */
    getPurchaseOrderHitoric(context, purchaseOrderId) {
      return axios.get(`${route}/historic/${purchaseOrderId}`)
    },

  },

}
